export default {
  "description": "Web developer JunKata website",
}